import { decorate, observable, action } from 'mobx';
import axios from 'axios';

class ThreeDSecureStore {
  constructor() {
    this.parameterId = '';
    this.loading = false;
    this.threeDSecure = {
      id: undefined,
      status: '',
      returnUrl: ''
    };
    this.notified = false;
  }

  setNotified(value) {
    this.notified = value;
  }

  setLoading(value) {
    this.loading = value;
  }

  setParameterId(value) {
    this.parameterId = value;
  }

  setThreeDSecure(data) {
    this.threeDSecure.id = data.id;
    this.threeDSecure.status = data.status;
    this.threeDSecure.returnUrl = data.returnUrl;
  }

  async loadData() {
    try {
      this.setLoading(true);

      this.setThreeDSecure({
        id: '',
        status: '',
        returnUrl: ''
      });

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/three_d_secures/${this.parameterId}`
      );

      const source = response.data.data;

      this.setThreeDSecure({
        id: source.id,
        status: source.attributes.status,
        returnUrl: source.attributes.redirect.return_url
      });

      this.setLoading(false);
    } catch (e) {
      // this.setLoading(false);
    }
  }
}

decorate(ThreeDSecureStore, {
  threeDSecure: observable,
  loading: observable,
  notified: observable,
  setNotified: action,
  setThreeDSecure: action,
  setLoading: action,
  setParameterId: action
});

export default ThreeDSecureStore;
